export default __webpack_public_path__ + "static/media/p5-7.9af3dd82.png";